export default {
  name: 'change-detail',
  created () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.search(false)
  },
  data () {
    var sortOrders = {}
    var columns = ['delivery-date', 'prescribe-change']
    columns.forEach(function(key) {
      sortOrders[key] = 1
    })

    return {
      columns: columns,
      sortKey: '',
      sortOrders: sortOrders
    }
  },
  computed: {
    reportChange () {
      var sortKey      = this.sortKey
      var order        = this.sortOrders[sortKey] || 1
      var reportChange = this.$store.getters.reportChange
      console.log(reportChange)
      if (sortKey) {
        reportChange = reportChange.slice().sort(function(a, b) {
          if (sortKey === 'delivery-date') {
            sortKey = 'sort-delivery-date'
          }

          a = a.attributes[sortKey]
          b = b.attributes[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      return reportChange
    },
    patient () {
      return this.$store.getters.patient
    },
    authToken() {
      return window.localStorage.getItem('access_token')
    }
  },
  methods: {
    search (readMore) {
      var url   = null
      var clear = true
      if (readMore) {
        url   = this.$store.getters.reportChangeNextPage
        clear = false
      }
      this.$store.dispatch('REPORT_CHANGE_SEARCH',  {url: url, clear: clear, patientId: this.$route.params.patientId})
    },
    sortBy (key) {
      this.sortKey = key
      if ( this.sortOrders[key] > 0) {
        this.sortOrders[key] = -1
      } else {
        this.sortOrders[key] = 1
      }
      console.log("Sorted by " + key + ".")
    },
    isSortKey (key) {
      return key === this.sortKey
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/change-detail.js